var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "employees-card-bottom" },
        [
          _c("oaFromBox", {
            attrs: {
              isTotal: false,
              isViewSearch: false,
              sortSearch: false,
              title: _vm.$route.meta.title,
            },
            on: { addDataFn: _vm.addAdminRole },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-box" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.roleList },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "角色名称",
                      prop: "role_name",
                      width: "150px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "管理范围", prop: "position" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getDataLevel(row.data_level)) +
                                "\n            "
                            ),
                            row.frame.length !== 0
                              ? _c(
                                  "span",
                                  [
                                    _vm._v("\n              ("),
                                    _vm._l(row.frame, function (item, index) {
                                      return _c("span", { key: index }, [
                                        _vm._v(" " + _vm._s(item.name) + " "),
                                      ])
                                    }),
                                    _vm._v(")\n            "),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "直属下级数据",
                      prop: "position",
                      width: "200px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(row.directly == 0 ? "不包含" : "包含") +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "使用成员数量",
                      prop: "user_count",
                      width: "150px",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "启用状态",
                      prop: "position",
                      width: "100px",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                width: 60,
                                "active-color": "#1890ff",
                                "active-text": "启用",
                                "inactive-color": "#909399",
                                "inactive-text": "禁用",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.setRoleStatus(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.status,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "status", $$v)
                                },
                                expression: "scope.row.status",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { fixed: "right", label: "操作", width: "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handelRole(scope.row)
                                  },
                                },
                              },
                              [_vm._v("管理成员")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDeleteRole(scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-drawer",
            {
              attrs: {
                "before-close": _vm.handleClose,
                visible: _vm.drawer,
                wrapperClosable: false,
                size: "700px",
                title: "管理人员",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawer = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "drawer-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _c("span", [_vm._v("管理人员")]),
                  _vm._v(" "),
                  _c("select-member", {
                    ref: "selectMember",
                    attrs: { value: _vm.tableList || [] },
                    on: { getSelectList: _vm.getSelectList },
                    scopedSlots: _vm._u([
                      {
                        key: "custom",
                        fn: function () {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small", type: "primary" },
                                on: { click: _vm.openDepartment },
                              },
                              [_vm._v("选择成员")]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableList },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { label: "ID", prop: "id" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "姓名", prop: "name" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "部门", prop: "frame.name" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "启用状态", prop: "position" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-text": _vm.$t("public.enable"),
                                    "active-value": 1,
                                    "inactive-text": _vm.$t("public.disabled"),
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleChange($event, scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "status", $$v)
                                    },
                                    expression: "scope.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          prop: "position",
                          width: "80px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDeleteUser(
                                          scope.row.id,
                                          scope.$index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("addAdminRole", {
        ref: "adminRole",
        attrs: { "edit-type": _vm.editType, "role-id": _vm.roleId },
        on: { adminRole: _vm.adminRole },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }